/* @ngInject */
export default (
  helperService,
  Address,
  Ownership,
  OwnershipType,
  PropertyType,
  TransactionType,
  ZoningOption,
  PropertyDetails
) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function SecuritySplit(
    id,
    idAsset,
    address,
    state,
    value,
    builderValue,
    monthlyRentalIncome,
    numberOfBoarders,
    transactionType,
    zoning,
    propertyType,
    ownershipType,
    guaranteeAmount,
    propertyDetails,
    allInclusive,
    toBeSold,
    valuation,
    ownership,
    isPrimary,
    isLimited,
    isNew
  ) {
    this.id = id;
    this.idAsset = idAsset;
    this.address = address;
    this.state = state;
    this.value = value;
    this.builderValue = builderValue;
    this.monthlyRentalIncome = monthlyRentalIncome;
    this.numberOfBoarders = numberOfBoarders;
    this.transactionType = transactionType;
    this.zoning = zoning;
    this.propertyType = propertyType;
    this.ownershipType = ownershipType;
    this.guaranteeAmount = guaranteeAmount;
    this.propertyDetails = propertyDetails;
    this.allInclusive = allInclusive;
    this.toBeSold = toBeSold;
    this.valuation = valuation;
    this.ownership = ownership;
    this.isPrimary = isPrimary;
    this.isLimited = isLimited;
    this.isNew = isNew;

    if (this.propertyDetails === undefined) {
      this.propertyDetails = new PropertyDetails({});
    }
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  SecuritySplit.Blank = function () {
    return SecuritySplit.Build({
      id: _.uuid(),
      idAsset: '',
      address: {},
      state: '',
      value: 0,
      builderValue: 0,
      monthlyRentalIncome: 0,
      numberOfBoarders: 0,
      transactionType: TransactionType.none,
      zoning: ZoningOption.none,
      propertyType: PropertyType.none,
      ownershipType: OwnershipType.none,
      guaranteeAmount: 0,
      propertyDetails: new PropertyDetails({}),
      allInclusive: false,
      toBeSold: false,
      valuation: false,
      ownership: [],
      isPrimary: false,
      isLimited: false,
      isNew: true
    });
  };
  SecuritySplit.Build = function (data) {
    return new SecuritySplit(
      data.id ? data.id : _.uuid(),
      data.idAsset ? data.idAsset : '',
      _.isEmpty(data.address) ? Address.blank() : Address.build(data.address),
      data.state ? data.state : '',
      data.value ? data.value : 0,
      data.builderValue ? data.builderValue : 0,
      data.monthlyRentalIncome ? data.monthlyRentalIncome : 0,
      data.numberOfBoarders ? data.numberOfBoarders : 0,
      TransactionType.of(data?.transactionType?.name || data?.transactionType?.toString()),
      ZoningOption.of(data?.zoning?.name || data?.zoning?.toString()),
      PropertyType.of(data?.propertyType?.name || data?.propertyType?.toString()),
      OwnershipType.of(data.ownershipType?.name || data?.ownershipType?.toString()),
      data.guaranteeAmount ? data.guaranteeAmount : 0,
      data?.propertyDetails
        ? new PropertyDetails(data.propertyDetails)
        : new PropertyDetails({}),
      data.allInclusive ? data.allInclusive : false,
      data.toBeSold ? data.toBeSold : false,
      data.valuation ? data.valuation : false,
      _.compact(_.map(data.ownership, (obj) => Ownership.build(obj))),
      data.isPrimary ? data.isPrimary : false,
      data.isLimited ? data.isLimited : false,
      data.isNew ? data.isNew : false
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  SecuritySplit.prototype.hasAddress = function () {
    return Address.hasAddress(this?.address);
  };
  SecuritySplit.prototype.getAddress = function () {
    return Address.getAddress(this?.address);
  };
  SecuritySplit.prototype.getName = function () {
    return this.hasAddress() ? this.getAddress() : 'New security';
  };
  SecuritySplit.prototype.getState = function () {
    const stateId = this.state;
    const availableStates = helperService.getAvailableStates();
    let state;
    if (availableStates && availableStates.length) {
      state = availableStates.find((s) => s.name === stateId);
    }
    return state ? state.title : 'N/A';
  };
  SecuritySplit.prototype.getValue = function () {
    return this.propertyType === 13 ||
      this.propertyType === 14 ||
      this.propertyType === 15 ||
      this.propertyType === 16
      ? this.value + this.builderValue
      : this.value;
  };

  return SecuritySplit;
};
